import React from "react";
import { Rules } from "../classes/Rules";

const rulesInitial: Rules = {} as any;

export const RulesContext = React.createContext({
  ...rulesInitial,
});
